import styled from "styled-components";

import { flex } from "../../../helpers/mixins";
import { fromThemeProps } from "../../../helpers/utilities";
import media from "../../../helpers/media";

const StyledColumn = styled.div`
  background: ${props => props.background || fromThemeProps("white")};
  ${flex({ dir: "column", jc: "center", ai: "center" })};
  display: ${(props) => {
    if (props.showDesktop) {
      return "none"
    }
    return "flex"
  }};
  position: relative;
  padding: 0 2em;
  padding-top: ${ props => props.paddingTop};

  ${media.xs`
      display: flex;
  `}
`

export default StyledColumn;


// WEBPACK FOOTER //
// ./src/styles/styledComponents/blocks/styledColumn.js